<template>
  <div>
    <button
      @click.prevent="closeConversation()"
      id="id-close-convo-btn"
      type="button"
      class="btn btn-rounded btn-danger btn-block"
    >
      Close Conversation
    </button>
  </div>
</template>


<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import { EventBus } from "@/events/eventBus";

export default {
  props: {
    conversationId: String
  },    
  computed: {
    ...mapGetters("user", ["currentToken"]),
    ...mapGetters("agency", ["currentAgency", "agencySettings"])
  },
  methods: {
    closeConversation() {
      EventBus.$emit("closeImageViewerModal");
      EventBus.$emit("closeVideoModal");

      setTimeout(async () => {
        if (confirm("Are you sure you want to terminate this conversation thread?")) {
          const resp = await this.$ConveyApi.conversationsApi.closeConversation({
            conversationId: this.conversationId,
            payload: {
              message_body: this.agencySettings.closedConversationMessage || "Some closing note"
            },
          });

          if (resp.status == 200) {
            this.$store.commit("conversations/closeConversation", this.conversationId);
            this.$router.push({ name: "Conversations Dashboard" }).catch(() => {});
          }
        }
      }, 500);
    }
  }
};
</script>
